import { render, staticRenderFns } from "./PTransparentLoader.vue?vue&type=template&id=516f3782&"
import script from "./PTransparentLoader.vue?vue&type=script&lang=js&"
export * from "./PTransparentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports